<template>
  <div class="real-name-auth">
    <el-card class="auth-card" shadow="never">
      <div class="auth-title">身份实名认证</div>
      <div class="auth-illustration">
        <img src="@/assets/image/promotionManage/real-name-auth.png" alt="实名认证">
      </div>
      <el-form ref="authForm" :model="form" :rules="rules" label-width="90px" class="auth-form">
        <el-form-item label="姓名" prop="realName">
          <el-input v-model.trim="form.realName" maxlength="10" placeholder="请输入" @input="handleRealNameInput"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCard">
          <el-input v-model.trim="form.idCard" maxlength="18" placeholder="请输入" @input="handleIdCardInput"></el-input>
        </el-form-item>
        <div class="auth-notice">首次进入需实名认证，请输入的信息与后台记录一致，否则将认证失败</div>
        <div class="auth-agreement">认证后代表已知悉同意和您签订的合同，充分了解了推广内容与情况</div>
        <el-form-item class="submit-item">
          <el-button type="primary" :loading="submitting" @click="submit">实名认证</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { submitRealNameAuth } from '@/api/promotionManage'

const idCardReg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
const realNameReg = /^[\u4e00-\u9fa5·]+$/

export default {
  name: 'promotionManage_realNameAuth',
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {
        realName: '',
        idCard: ''
      },
      rules: {
        realName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { max: 10, message: '姓名最多10个字', trigger: 'blur' },
          { min: 2, message: '姓名至少2个字', trigger: 'blur' },
          { validator: (rule, value, callback) => realNameReg.test(value) ? callback() : callback(new Error('姓名格式不正确')), trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: (rule, value, callback) => idCardReg.test(value) ? callback() : callback(new Error('格式不正确')), trigger: 'blur' }
        ]
      },
      submitting: false
    }
  },
  computed: {
    ...mapState('user', {
      userInfo: state => state.userInfo
    }),
    mobile () {
      return this.userInfo.mobile || ''
    }
  },
  methods: {
    // 姓名仅允许输入中文字符和民族姓名分隔符
    handleRealNameInput (value) {
      this.form.realName = value.replace(/[^\u4e00-\u9fa5·]/g, '')
    },
    // 身份证号只允许输入数字和字母X
    handleIdCardInput (value) {
      this.form.idCard = value.replace(/[^0-9xX]/g, '')
    },
    submit () {
      this.$refs.authForm.validate(async valid => {
        if (!valid) return
        try {
          this.submitting = true
          const result = await submitRealNameAuth({
            mobile: this.mobile,
            name: this.form.realName,
            idCardNo: this.form.idCard
          })
          if (![0, 200].includes(result.code) || (result.result && result.result.success === false)) {
            this.$message.error(result.message || '认证失败')
            return
          }
          this.$message.success('认证成功')
          if (this.embedded) {
            this.$emit('authenticated')
            return
          }
          this.$router.replace(this.$route.query.redirect || '/promotionManage/promoterRule')
        } catch (error) {
          this.$message.error('认证失败，请稍后重试')
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.real-name-auth {
  padding: 30px 20px 60px;
  background: #f8f9fd;
}
.auth-card {
  min-height: calc(100vh - 180px);
  padding-top: 30px;
  border: 0;
  border-radius: 15px;
  display: flex;
  justify-content: center;  
  align-items: center;

}
.auth-card /deep/ .el-card__body {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.auth-title {
  margin-bottom: 20px;
  font-size: 40px;
  font-weight: 600;
  color: #222;
  text-align: center;
}
.auth-illustration {
  display: flex;
  width: 390px;
  height: 143px;
  margin: 0 auto 60px;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.auth-form {
  width: 680px;
  margin: 0 auto;
}
.auth-form /deep/ .el-form-item {
  margin-bottom: 26px;
}
.auth-form /deep/ .el-form-item__label {
  color: #8993a3;
  font-size: 16px;
}
.auth-form /deep/ .el-input__inner {
  height: 46px;
  border: 0;
  border-radius: 10px;
  background: #f5f6f8;
}
.auth-notice {
  width: 680px;
  margin: 10px auto 25px;
  color: #222;
  font-size: 16px;
  text-align: center;
}
.auth-agreement {
  margin-bottom: 22px;
  color: #222;
  font-size: 16px;
  text-align: center;
}
.submit-item {
  text-align: center;
}
.submit-item /deep/ .el-form-item__content {
  margin-left: 0 !important;
}
.submit-item .el-button {
  width: 445px;
  height: 56px;
  border: 0;
  border-radius: 30px;
  background: #287cf4;
  font-size: 18px;
}
.code-input {
  width: 220px;
  margin-right: 10px;
}
@media screen and (max-width: 760px) {
  .auth-card {
    padding: 60px 10px 20px;
  }
  .auth-illustration,
  .auth-form,
  .auth-notice {
    width: 100%;
  }
  .auth-illustration {
    transform: scale(.8);
  }
  .auth-notice {
    // margin-bottom: 50px;
  }
  .submit-item .el-button {
    width: 80%;
  }
}
</style>
